import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9slg9d8o1vn02ekuhf0';

export default function AboutPage() {

  const seoData = {
    title: '关于我们 - 免费电影在线观看平台 | 光影在线',
    description: '光影在线致力于为用户提供免费、高清、流畅的在线观影体验。海量影片资源，无需注册，多端播放。了解我们的品牌故事、用户口碑和联系方式。',
    keywords: '光影在线,免费电影网站,在线看电影,关于我们,电影网站推荐,免费观影平台',
    canonicalUrl: 'https://guangyingzx.com/about',
    schemaJson: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          name: '光影在线',
          url: 'https://guangyingzx.com',
          description: '免费电影在线观看平台，提供海量高清影片资源',
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '400-888-8888',
            contactType: 'customer service',
            availableLanguage: ['Chinese'],
          },
          address: {
            '@type': 'PostalAddress',
            streetAddress: '朝阳区光影大厦',
            addressLocality: '北京',
            addressCountry: 'CN',
          },
        },
        {
          '@type': 'WebPage',
          name: '关于我们 - 光影在线',
          url: 'https://guangyingzx.com/about',
        },
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: '光影在线是否需要注册才能观看？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '不需要！光影在线完全免费，无需注册即可观看所有影片。',
              },
            },
            {
              '@type': 'Question',
              name: '光影在线支持哪些设备？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '支持手机、平板、电脑等多端播放，随时随地畅享观影体验。',
              },
            },
            {
              '@type': 'Question',
              name: '影片画质如何？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '我们提供高清及以上画质，确保您获得最佳的观影体验。',
              },
            },
          ],
        },
      ],
    },
  };

  return (
    <>
      <SEOHead {...seoData} />
      <ScrollToTop />
      <Navbar />
      <main className="pt-20">
        <nav className="px-4 md:px-6 py-4">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-primary-600 font-medium whitespace-nowrap">关于我们</span>
            </div>
          </div>
        </nav>

        <section className="px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
              关于光影在线
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              光影在线成立于2020年，致力于为广大影视爱好者提供
              <strong className="text-foreground-900">免费、高清、流畅</strong>
              的在线观影体验。我们相信，好电影应该被更多人看到。
            </p>
          </div>
        </section>

        <section className="px-4 md:px-6 py-12 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center p-6">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-eye-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2">我们的使命</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  让每一个人都能轻松享受高质量的观影体验，打破付费墙的束缚，让好电影触手可及。
                </p>
              </div>

              <div className="text-center p-6">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-star-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2">我们的愿景</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  成为中文互联网最受欢迎的免费观影平台，用技术和内容连接每一个热爱电影的人。
                </p>
              </div>

              <div className="text-center p-6">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2">我们的承诺</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  始终坚持免费、高清、无广告打扰的观影体验，尊重每一位用户的观影需求。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-12 md:py-16">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                品牌故事
              </h2>
              <p className="text-sm text-foreground-500">从一个小小的想法，到服务数百万用户的平台</p>
            </div>

            <div className="max-w-3xl mx-auto">
              <div className="space-y-8">
                <div className="flex gap-5">
                  <div className="shrink-0">
                    <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
                      <span className="text-background-50 font-bold text-sm">2020</span>
                    </div>
                    <div className="w-px h-full bg-background-200 mx-auto mt-2"></div>
                  </div>
                  <div className="pb-8">
                    <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">初创立项</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      三位热爱电影的程序员在咖啡厅的一次聊天中，萌生了打造一个免费电影网站的想法。他们发现现有的观影平台要么收费高昂，要么体验糟糕。于是，「光影在线」应运而生。
                    </p>
                  </div>
                </div>

                <div className="flex gap-5">
                  <div className="shrink-0">
                    <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
                      <span className="text-background-50 font-bold text-sm">2021</span>
                    </div>
                    <div className="w-px h-full bg-background-200 mx-auto mt-2"></div>
                  </div>
                  <div className="pb-8">
                    <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">产品上线</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      经过一年的开发和内容积累，光影在线正式上线。上线首月即获得10万用户，口碑迅速传播。无需注册、高清流畅的特点深受用户喜爱。
                    </p>
                  </div>
                </div>

                <div className="flex gap-5">
                  <div className="shrink-0">
                    <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
                      <span className="text-background-50 font-bold text-sm">2023</span>
                    </div>
                    <div className="w-px h-full bg-background-200 mx-auto mt-2"></div>
                  </div>
                  <div className="pb-8">
                    <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">飞速成长</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      用户突破200万，影片资源超过5000部。完成了多端适配的全面升级，手机、平板、电脑均可流畅观影。上线智能推荐系统，让用户更容易发现喜欢的影片。
                    </p>
                  </div>
                </div>

                <div className="flex gap-5">
                  <div className="shrink-0">
                    <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                      <span className="text-background-50 font-bold text-sm">2026</span>
                    </div>
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">行业领先</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      如今，光影在线已拥有超过500万活跃用户，影片资源突破10000部，涵盖30多个品类。我们持续优化产品体验，致力于成为中文互联网最好的免费观影平台。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-500">听听他们怎么说</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 rounded-xl p-6 border border-background-200">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-sm text-primary-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "画质真的太棒了！而且完全不用注册，打开就能看。片源也很丰富，最新的电影基本都有。已经推荐给身边所有朋友了！"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                    <span className="text-primary-600 font-semibold text-xs">李</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">李同学</p>
                    <p className="text-xs text-foreground-500">大学生</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-xl p-6 border border-background-200">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-sm text-primary-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "用了快两年了，从学生时代一直用到现在工作。分类很清晰，更新也快。周末窝在家看电影简直太享受了！"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <span className="text-accent-600 font-semibold text-xs">王</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">王小姐</p>
                    <p className="text-xs text-foreground-500">设计师</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-xl p-6 border border-background-200">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-sm text-primary-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "家里老人小孩都在用，操作简单不需要教。关键是免费还高清，比那些收费的APP好用多了。强烈推荐！"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                    <span className="text-secondary-600 font-semibold text-xs">张</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">张先生</p>
                    <p className="text-xs text-foreground-500">自由职业者</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-12 md:py-16">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                常见问题
              </h2>
              <p className="text-sm text-foreground-500">你可能想了解的信息</p>
            </div>

            <div className="space-y-3">
              <details className="group bg-background-100 rounded-xl p-5 cursor-pointer">
                <summary className="flex items-center justify-between font-heading font-semibold text-sm text-foreground-900">
                  光影在线是否需要注册才能观看？
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform text-lg text-foreground-500"></i>
                </summary>
                <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                  不需要！光影在线完全免费，无需注册即可观看所有影片。我们坚信好电影应该触手可及。
                </p>
              </details>

              <details className="group bg-background-100 rounded-xl p-5 cursor-pointer">
                <summary className="flex items-center justify-between font-heading font-semibold text-sm text-foreground-900">
                  光影在线支持哪些设备？
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform text-lg text-foreground-500"></i>
                </summary>
                <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                  支持手机、平板、电脑等多端播放，随时随地畅享观影体验。只需打开浏览器即可，无需下载任何APP。
                </p>
              </details>

              <details className="group bg-background-100 rounded-xl p-5 cursor-pointer">
                <summary className="flex items-center justify-between font-heading font-semibold text-sm text-foreground-900">
                  影片画质如何？
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform text-lg text-foreground-500"></i>
                </summary>
                <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                  我们提供高清及以上画质，确保您获得最佳观影体验。大部分影片支持1080P高清播放，部分影片支持4K画质。
                </p>
              </details>

              <details className="group bg-background-100 rounded-xl p-5 cursor-pointer">
                <summary className="flex items-center justify-between font-heading font-semibold text-sm text-foreground-900">
                  影片多久更新一次？
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform text-lg text-foreground-500"></i>
                </summary>
                <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                  我们保持每日更新，最新院线大片和热门剧集会在第一时间上线，确保你不会错过任何精彩内容。
                </p>
              </details>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500">有任何问题或建议？欢迎与我们取得联系</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
              <div className="bg-background-50 rounded-xl p-5 text-center border border-background-200">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">电子邮箱</p>
                <p className="text-sm font-medium text-foreground-900 whitespace-nowrap">contact@guangyingzx.com</p>
              </div>

              <div className="bg-background-50 rounded-xl p-5 text-center border border-background-200">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">客服电话</p>
                <p className="text-sm font-medium text-foreground-900 whitespace-nowrap">400-888-8888</p>
              </div>

              <div className="bg-background-50 rounded-xl p-5 text-center border border-background-200">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">公司地址</p>
                <p className="text-sm font-medium text-foreground-900 whitespace-nowrap">北京市朝阳区光影大厦</p>
              </div>
            </div>

            <div className="bg-background-50 rounded-xl p-6 border border-background-200">
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-4 text-center">发送消息</h3>
              <form
                data-readdy-form
                action={FORM_SUBMIT_URL}
                method="POST"
                className="space-y-4"
                onSubmit={(e) => {
                  e.preventDefault();
                  const honeypot = (e.currentTarget.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
                  if (honeypot) return;

                  const form = e.currentTarget as HTMLFormElement;
                  const formData = new FormData(form);
                  const params = new URLSearchParams();
                  formData.forEach((value, key) => {
                    if (key !== 'phone_alt') params.append(key, value.toString());
                  });

                  fetch(form.action, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: params.toString(),
                  })
                    .then(async (res) => {
                      const text = await res.text();
                      let data;
                      try { data = JSON.parse(text); } catch { data = null; }
                      form.reset();
                      const msgEl = document.getElementById('form-msg');
                      if (msgEl) msgEl.textContent = '感谢您的留言，我们会尽快回复！';
                    })
                    .catch(() => {
                      const msgEl = document.getElementById('form-msg');
                      if (msgEl) msgEl.textContent = '发送失败，请稍后重试';
                    });
                }}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-foreground-700 mb-1.5">姓名</label>
                    <input
                      type="text"
                      name="name"
                      required
                      className="w-full px-3 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-foreground-700 mb-1.5">邮箱</label>
                    <input
                      type="email"
                      name="email"
                      required
                      className="w-full px-3 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">主题</label>
                  <input
                    type="text"
                    name="subject"
                    required
                    className="w-full px-3 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入消息主题"
                  />
                </div>

                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">留言内容</label>
                  <textarea
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    className="w-full px-3 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言（最多500字）"
                  ></textarea>
                  <p className="text-xs text-foreground-500 mt-1">最多500个字符</p>
                </div>

                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="visually-hidden-field"
                />

                <div className="text-center">
                  <button
                    type="submit"
                    className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-send-plane-line mr-2"></i>
                    发送消息
                  </button>
                </div>

                <p id="form-msg" className="text-center text-sm text-primary-600 font-medium"></p>
              </form>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}